/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ user: NonNullable<unknown> }} Recent_Payment_DropInputs */

const fr_recent_payment_drop = /** @type {(inputs: Recent_Payment_DropInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.user} a payé pour un drop-in`)
};

/**

* @param {Recent_Payment_DropInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const recent_payment_drop = /** @type {((inputs: Recent_Payment_DropInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recent_Payment_DropInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_recent_payment_drop(inputs)
});